module.exports = __webpack_public_path__ + "static/img/RobertWhittaker.9f1d37e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RobertWhittaker.jpg
// module id = lW/x
// module chunks = 0